var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopeNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.08 6.602V17.93H4.92V6.602zm0-1.2H4.92a1.2 1.2 0 0 0-1.2 1.2V17.93a1.2 1.2 0 0 0 1.2 1.2h14.16a1.2 1.2 0 0 0 1.2-1.2V6.602a1.2 1.2 0 0 0-1.2-1.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.607 7.886c-.1 0-.2.03-.286.084l-5.32 3.41L6.68 7.969a.533.533 0 0 0-.818.446c0 .18.088.346.24.444L12 12.728l5.899-3.87a.531.531 0 0 0-.293-.974z"
})));
export default SvgEnvelopeNew;